import { GlobalSetting, GlobalSettingType } from 'model'
import React from 'react'

export const GlobalSettingsContext = React.createContext<{
  getSetting: (type: GlobalSettingType) => GlobalSetting | undefined
  allSettings: GlobalSetting[]
}>({ getSetting: (type: GlobalSettingType) => void 0, allSettings: [] })
